import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const MODULE_VERSION_RESOURCES_TABLE_STORAGE_KEY = "moduleVersionResourcesTableStorageKey";
export const MODULE_VERSION_RESOURCES_TABLE_FILTERS_STORAGE_KEY =
  "moduleVersionResourcesTableFiltersStorageKey";

export enum MODULE_VERSION_RESOURCES_COLUMN_ID {
  NAME = "NAME",
}

export const MODULE_VERSION_RESOURCES_TABLE_COLUMNS_CONFIG: Record<
  MODULE_VERSION_RESOURCES_COLUMN_ID,
  TableColumnMeta
> = {
  [MODULE_VERSION_RESOURCES_COLUMN_ID.NAME]: {
    id: MODULE_VERSION_RESOURCES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: 2000,
    allowsSorting: true,
    // The only column: nothing to hide, pin, move, or resize against, so all of that chrome is off.
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<MODULE_VERSION_RESOURCES_COLUMN_ID, string> = {
  [MODULE_VERSION_RESOURCES_COLUMN_ID.NAME]: "name",
};

export const INITIAL_SORT_OPTION = SORT_CONFIG[MODULE_VERSION_RESOURCES_COLUMN_ID.NAME];
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;
